enum TransactionsOptions {
    Cleared = "CLEARED",
    Pending = "PENDING"
}
export default TransactionsOptions;